export default __webpack_public_path__ + "static/media/QSGRW_Imagery_Satellite.aac74f09.png";